import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/guide/page";
import ShippingTipsPage from "../pages/guide/shipping-tips/page";
import QCChecklistPage from "../pages/guide/qc-checklist/page";
import BestSellersPage from "../pages/guide/best-sellers/page";
import ShoeFindsPage from "../pages/guide/shoe-finds/page";
import HoodieGuidePage from "../pages/guide/hoodie-guide/page";
import BagCollectionPage from "../pages/guide/bag-collection/page";
import BeginnerTipsPage from "../pages/guide/beginner-tips/page";
import SafetyGuidePage from "../pages/guide/safety-guide/page";
import SizingGuidePage from "../pages/guide/sizing-guide/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/guide", element: <GuidePage /> },
  { path: "/guide/shipping-tips", element: <ShippingTipsPage /> },
  { path: "/guide/qc-checklist", element: <QCChecklistPage /> },
  { path: "/guide/best-sellers", element: <BestSellersPage /> },
  { path: "/guide/shoe-finds", element: <ShoeFindsPage /> },
  { path: "/guide/hoodie-guide", element: <HoodieGuidePage /> },
  { path: "/guide/bag-collection", element: <BagCollectionPage /> },
  { path: "/guide/beginner-tips", element: <BeginnerTipsPage /> },
  { path: "/guide/safety-guide", element: <SafetyGuidePage /> },
  { path: "/guide/sizing-guide", element: <SizingGuidePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;